import api from "./api";

export const createPaymentIntent = async (payload) => {
    const shipmentId =
        typeof payload === "number"
            ? payload
            : Number(payload.shipmentId);

    const body = {
        shipmentId,
    };

    if (payload?.amount && Number(payload.amount) > 0) {
        body.amount = Number(payload.amount);
    }

    const { data } = await api.post("/stripe/payment-intent", body);

    return data;
};

export const getPaymentStatus = async (paymentIntentId) => {
    const { data } = await api.get(`/stripe/status/${paymentIntentId}`);
    return data;
};